import { render, staticRenderFns } from "./uploadCom.vue?vue&type=template&id=35af102c&scoped=true"
import script from "./uploadCom.vue?vue&type=script&lang=js"
export * from "./uploadCom.vue?vue&type=script&lang=js"
import style0 from "./uploadCom.vue?vue&type=style&index=0&id=35af102c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35af102c",
  null
  
)

export default component.exports